import { UserProfileService } from './../../services/user-profile.service';
import { Component, OnInit } from '@angular/core';
import { UserProfile_Document, User, ADUser } from '../../model/user-profile';
import { ActivatedRoute, Router } from '@angular/router';
import { DialogService } from 'projects/Shared-Lib/component/dialog/dialog.service';
import { FilterDataService } from '../../services/filter-data.service';

import { AppService } from '../../services/app.service';
import { NGXLogger } from 'ngx-logger';

@Component({
  selector: 'app-user-profile-edit',
  templateUrl: './user-profile-edit.component.html',
  styleUrls: ['./user-profile-edit.component.css'],
  providers: [UserProfileService]
})
export class UserProfileEditComponent implements OnInit {
  Doc: UserProfile_Document;
  // NEW or edit
  IsNew: boolean;
  UserId: string;
  Title: string;
  // controllerName = 'UserProfile';
  selectedItems = [];
  dropdownSettings = {};

  constructor(private route: ActivatedRoute, private dlgService: DialogService,
    private appService: AppService, private filterService: FilterDataService,
    private router: Router, UserService: UserProfileService) {

    this.Doc = new UserProfile_Document(dlgService, UserService);
    this.Doc.UserAccount = '';
    this.Doc.SelectEnabled = 'Y';

    this.dropdownSettings = {
      singleSelection: false,
      idField: 'value',
      textField: 'text',
      selectAllText: 'Select All',
      unSelectAllText: 'UnSelect All',
      itemsShowLimit: 6,
      allowSearchFilter: true
    };
  }

  ngOnInit() {
    this.UserId = this.route.snapshot.paramMap.get('id');
    if (this.UserId) {
      // edit mode
      // this.Doc.GetDocument(this.UserId, (data) => {this.OnDataSrvEnd(); }); // Old version GLS Regions combo box use

      // Start for update GLS Regions combo box
      this.Doc.GetDocument(
        this.UserId,
        (data) => {
          this.OnDataSrvEnd();
        }
      );
      // End for update GLS Regions combo box

      this.IsNew = false;
      this.Title = 'Edit';
    } else {
      // create mode
      this.Doc.initViewData(true, (data) => { this.OnDataSrvEnd(); });
      this.Title = 'Create';
      this.IsNew = true;
    }
  }


  isValid(): boolean {
    if
      (
      (this.Doc.UserAccount && this.Doc.UserAccount !== '')
      &&
      (this.Doc.UserName && this.Doc.UserName !== '')
      &&
      (this.Doc.EMail && this.Doc.EMail !== '')
    ) {
      return false;
    }

    return true;
  }

  GetADInfo(UserAccount: string) {
    this.Doc.GetADInfo(UserAccount);
  }

  CanGetADInfo() {
    if ((this.Doc.UserAccount !== '' && this.Doc.UserAccount !== null)) {
      return false;
    }

    return true;
  }

  Submit() {
    if (this.IsNew) {
      this.Doc.Create()
        .subscribe(data => {
          if (data.Success) {
            let result = this.dlgService.CreateSubmit();
            result.then((ret) => {
              if (ret === 'Back') {
                this.Cancel();
              }
              else if (ret === 'Create Another') {
                this.Doc.UserAccount = '';
                this.Doc.UserName = '';
                this.Doc.EMail = '';
                this.Doc.SelectEnabled = 'Y';
              }
            }).catch((error) => {
              console.error(error);
            });
          }
          else {
            //this error message handle in interceptor
            let result = this.dlgService.ErrorInformation(data.Message);
            result.then((ret) => {
            }).catch((error) => {
              console.error(error);
            });
          }
        })
    }
    else if (this.Doc.UserId && !this.IsNew) {
      this.Doc.Save().subscribe(data => {
        if (data.Success) {
          let result = this.dlgService.EditSubmit();
          result.then((ret) => {
            if (ret === 'Back') {
              this.Cancel();
            }
          }).catch((error) => {
            console.error(error);
          });
        }
      });
    }
  }

  Cancel() {
    let lastPageInfo = this.filterService.GetSearchInfo();
    console.log(lastPageInfo);
    if (lastPageInfo.RouteName) {
      this.router.navigate([lastPageInfo.RouteName]);
    }
    else
      this.router.navigate(['/Auth/UserProfile']);
  }

  AccountChange(event) {
    this.Doc.UserName = '';
    this.Doc.EMail = '';
  }

  OnDataSrvEnd() {
    setTimeout(() => this.appService.SetLoadingState(false), 0);
  }
}
